import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {TenantConfigService} from "@rsp/shared/services/tenant-config.service";


@Injectable()
export class ImageUrlBuilderService {

  constructor(private tenantConfig: TenantConfigService) {
  }

  public getPrefix(): string {
    return environment.baseUrlApi + "/tenant/" + this.tenantConfig.getId();
  }

  public getMultimediaPath(filePath: string): string {
    return this.getPrefix() + "/multimediafile/" + filePath;
  }

  public getProductionsitePath(filePath: string): string {
    return this.getPrefix() + "/productionsite-image/" + filePath;
  }
}
